import React from "react";
import PropTypes from "prop-types";
import "./UploadFooter.css";
import { calculateEstimatedAmount, formatPrice } from "../../../util/util";

/**
 * 업로드 화면 푸터
 * 네고 가능 여부와 예상 정산금액을 표시하고 하단에 고정됨
 */
const UploadFooter = ({ register, watch }) => {
  const currentPrice = watch("price") || 0;
  const shippingFee = watch("shipping_fee") || 0;
  const feeAssigned = watch("fee_assigned");

  return (
    <div className="UploadFooter-container">
      <div className="UploadFooter-negotiation">
        <div className="checkbox-container">
          <label className="toggle">
            <input type="checkbox" {...register("isNegotiable")} />
            <span className="toggle-slider"></span>
          </label>
        </div>
        <span className="title">네고 제안받기</span>
      </div>

      <div className="UploadFooter-estimated">
        <div className="label">예상 정산 금액</div>
        <div className="amount">
          {formatPrice(
            calculateEstimatedAmount(feeAssigned, currentPrice, shippingFee),
          )}
          <span>원</span>
        </div>
      </div>
    </div>
  );
};

UploadFooter.propTypes = {
  register: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default UploadFooter;
